module.exports = __webpack_public_path__ + "static/media/tv-mock.78dc274d.png";